import React from 'react'
import Helmet from 'react-helmet'
import './NoMatch.scss'

const metaData = {
  meta: [
    {
      name: 'robots',
      content: `noindex, nofollow`
    }
  ]
}

const NoMatch = () => (
  <div className='clearfix'>
    <Helmet {...metaData} />
    <div className='sc-container container no-match'>
      <h2 className='no-match-title h1'>Store not found</h2>
      <p className='no-match-text'>The requested page could not be found</p>
      <p>
        <a href='/stores/' className='no-match-link link' data-el='btn-back-to-help-home'>
          Back to stores home
        </a>
      </p>
    </div>
  </div>
)

export default NoMatch



// WEBPACK FOOTER //
// ./src/containers/NoMatch/NoMatch.jsx